const searchBtnMobile = document.querySelector('.search__button-mobile');
const searchCloseBtnMobile = document.querySelector('.search-modal-mobile .search-modal__close-button');
const searchDetailsMobile = document.querySelector('.search-modal-mobile');
const searchIcon = document.querySelector('.search__button-icon');
// const menuDrawer = document.querySelector('.menu-drawer-container');

searchBtnMobile.addEventListener("click", event => {
    searchDetailsMobile.classList.remove("hidden");
    document.body.classList.add('overflow-hidden-tablet');
});

searchIcon.addEventListener("click", event => {
    if ((window.innerWidth >= 990) && (window.innerWidth <= 1250)) {
        document.querySelector('.menu-drawer-container').removeAttribute('open')
    }
    searchDetailsMobile.classList.remove("hidden");
    document.body.classList.add('overflow-hidden-tablet');
});

searchCloseBtnMobile.addEventListener("click", event => {
    event.preventDefault();
    searchDetailsMobile.classList.add("hidden");
    if( !document.querySelector('.menu-drawer-container').hasAttribute('open') ){
        document.body.classList.remove('overflow-hidden-tablet');
    }
});